export const maxInputLength = 256;
export const minInputLength = 2;